import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true
})

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const { status } = error.response

      if (status === 401 || status === 403) {
        localStorage.removeItem('is_authorized')
        window.location.reload()
      }
    }

    return Promise.reject(
      (error.response && error.response.data) || 'Something went wrong'
    )
  }
)

export default axiosInstance
